import { Card, Grid, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { ObjectiveReportsPostsecondaryEducationEnrollment } from "generated/openApi";

export const ObjectivePostsecondaryEducationEnrollment = (props: {
  title: string;
  objective: ObjectiveReportsPostsecondaryEducationEnrollment;
}) => {
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  return (
    <Card header={props.title}>
      <Grid ref={breakpointsRef} container spacing="lg" maxWidth="1000px">
        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Graduates
            </Typography>
            <Typography variant="h6">{props.objective.graduates}</Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Summer/Fall Enrollment
            </Typography>
            <Typography variant="h6">
              {/* {props.objective.summerEnrollment}/{props.objective.fallEnrollment} */}
              {props.objective.totalEnrollment}
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={setBreakpoints({ md: 4, xs: 12 })} alignItems="center" display="flex" justifyContent={"center"}>
          <Stack spacing="md" justifyContent={"center"} alignItems="center">
            <Typography variant="body1" textAlign={"center"}>
              Summer/Fall Enrollment %
            </Typography>
            <Typography variant="h6">
              {/* {props.objective.summerEnrollmentPercent?.toFixed(2)}%/{props.objective.fallEnrollmentPercent?.toFixed(2)} */}
              {props.objective.totalEnrollmentPercent?.toFixed(2)}%
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
};
